// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {clamp} from '@benchling/js-utils';
import * as d3 from 'd3';
import _ from 'underscore';

import GapSequenceWrapper from 'analyses/alignment/GapSequenceWrapper';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {MenuChoicesOptions} from 'components/SelectionContextMenuHelpers';
import {Sequence} from 'components/Sequence';
import * as context from 'Context';
import {Translations, ORFs, LinearLayout} from 'molbio/maps/linear/LinearLayout';
import TranslationLayeredView, {TranslationsViewOptions} from 'molbio/maps/linear/TranslationLayeredView';
import {SequenceMapPreferences} from 'molbio/maps/SequenceMapConstants';
import * as sequtil from 'molbio/SeqUtil';
import ORF from 'molbio/translations/backbone/ORF';
import preferences from 'Preferences';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {Optional} from 'util/Types';

class ORFsView extends TranslationLayeredView<ORF> {
  visibilityOption!: vo.VisibilityOption;

  static initClass(): void {
    this.prototype.className = 'orfs';
    this.prototype.setting = vo.ORFS.name;
  }
  getData(start: number, end: number): Array<ORF> {
    const sequence = this.model.sequence<Sequence | GapSequenceWrapper>();
    // TODO: Use preference values here. Right now it doesn't matter because visibility options will
    // trigger another re-render with updated values for all options, but they will be incorrect on the first
    // render which will cause an error in `sliceAndFilter` (which depends on `startCodon`).
    const minLength = this.visibilityOption.getSetting('minimum-orf-length')!.get('value');
    const frame = this.visibilityOption.getSetting('orf-frame')!.get('value');
    // Generally visibility options control what data is rendered (and when to re-render), but visibility
    // options are also synced to preferences which is why we can use that here.
    const startCodon = preferences.get(SequenceMapPreferences.ORF_START_CODON);
    const options = {minLength, frame, sequence, startCodon};
    const orfs = sequence.orfs().sliceAndFilter(start, end, options);
    return orfs;
  }

  getLayout(): Translations | ORFs {
    if (this.showAAs()) {
      // @ts-expect-error: TS cannot handle multiple interfaces with generics
      return (this.model.get('layout') as LinearLayout).Translations;
    } else {
      // @ts-expect-error: TS cannot handle multiple interfaces with generics
      return (this.model.get('layout') as LinearLayout).ORFs;
    }
  }
  isShown(): boolean {
    return this.shouldShow();
  }
  contextMenuOptions(): Array<string> {
    return selectioncontextmenu.getSelectionMenu();
  }
  contextMenuData(d: ORF): MenuChoicesOptions {
    return {orf: d, feature: d};
  }

  initialize(options: TranslationsViewOptions): void {
    super.initialize(options);
    this.tabstate = options.tabstate;
    // @ts-expect-error: TS cannot handle multiple interfaces with generics
    this.layout = (this.model.get('layout') as LinearLayout).ORFs;
    this.visibilityOption = this.tabstate.get('visibilityOptions').getOption('orfs');
    this.opacityFactor = 0.65;
    this.fontOpacityFactor = 0.7;
    this.enableMousedown = false;
  }

  strokeColor(): string {
    return '#00AA00';
  }

  showAAs(): boolean {
    if (this.parent.mapType !== 'linear') {
      // See: client/settings/visibility-options/VisibilityOptions.js: show-orf-amino-acids is only meant for sequence map
      return false;
    }
    return Boolean(
      __guard__(this.visibilityOption.getSetting('show-orf-amino-acids'), (x) => x.get('value'))
    );
  }

  layerFillOpacity(d: ORF): number {
    return 1.0;
  }

  layerFill(d: ORF): string {
    if (d.get('hover') || d.selected()) {
      return d3.rgb(d.color()).darker().formatHex();
    } else {
      return d.color();
    }
  }

  registerListeners(): void {
    super.registerListeners();

    const orfs = this.model.sequence<Sequence | GapSequenceWrapper>().orfs();
    this.listenTo(orfs, 'change:hover change:selected', (model: ORF, value: boolean) => {
      if (!this.showAAs()) {
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        return this.handleHoverSelect(model, value);
      }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return this.listenTo(orfs, 'click', this.pieceClickHandler);
  }

  clickAction(e: Event, d: ORF): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return d.click(this.model.sequence<Sequence | GapSequenceWrapper>(), (e as MouseEvent).shiftKey);
  }

  dblClickAction(e: Event, d: ORF): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return d.dblClick(this.model.sequence<Sequence | GapSequenceWrapper>(), (e as MouseEvent).shiftKey);
  }

  pieceClickHandler(e: Event, d: ORF): void {
    const xInv = this.slice.xInv();
    const index = Math.floor(xInv(d3.pointer(e, this.parent.el)[0]));
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return context.using(
      {isLinear: this.isLinear, mapId: this.model.cid, index},
      this,
      function (this: ORFsView) {
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        return this.clickAction(e, d);
      }
    );
  }

  pieceDblClickHandler(e: Event, d: ORF): void {
    const xInv = this.slice.xInv();
    const index = Math.floor(xInv(d3.pointer(e, this.parent.el)[0]));
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return context.using(
      {isLinear: this.isLinear, mapId: this.model.cid, index},
      this,
      function (this: ORFsView) {
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        return this.dblClickAction(e, d);
      }
    );
  }

  rerenderSingle(
    el: SVGElement,
    start: number,
    end: number,
    dx: number,
    dy: number,
    d: ORF,
    xx: number,
    yy: number
  ): void {
    let i;
    if (this.showAAs()) {
      d3.select(el).selectAll('.layer-fill').remove();
      d3.select(el).selectAll('.hidden-background').remove();
      d3.select(el).selectAll('.start-positions').remove();
      d3.select(el).selectAll('.end-positions').remove();
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      return super.rerenderSingle(el, start, end, dx, dy, d, xx, yy);
    } else {
      let getStartPath: (i: number) => string;
      d3.select(el).selectAll('.amino-acid-group').remove();
      const enter = d3.select(el).data([d]);
      enter.append('svg:path').classed('layer-fill', true).classed('line', true);
      enter.append('svg:path').classed('hidden-background', true);
      enter.append('svg:g').classed('start-positions', true);
      enter.append('svg:g').classed('end-positions', true);
      const sliceStart = this.slice.start();
      const sliceEnd = this.slice.end();
      start = clamp(sliceStart, sliceEnd, start);
      end = clamp(sliceStart, sliceEnd, end);
      const strand = d.strand();
      const width = dx;
      // When showAAs() is falsey, getLayout returns the ORFs layout.
      const lineHeight = (this.getLayout() as ORFs).get('single').get('lineHeight');
      const height = (this.getLayout() as ORFs).get('single').get('height');

      const x = this.slice.x();

      const shouldShow = (index: number): boolean =>
        // eslint-disable-next-line no-restricted-syntax
        _.some(__range__(index, index + 3 * strand, false), (i) =>
          sequtil.baseInRange(i, sliceStart, sliceEnd)
        );

      // eslint-disable-next-line no-restricted-syntax
      const starts = _.filter(d.startPositions(), (i) => shouldShow(i));
      // @ts-expect-error: unused variable
      // eslint-disable-next-line no-restricted-syntax
      const ends = _.filter([d.endPosition()], (i) => i != null && shouldShow(i));

      const endOffset = strand === -1 ? 1 : 0;
      const offset = start - sliceStart;

      const length = x(sliceStart + 3) - x(sliceStart);
      const THRESHOLD = 3;

      if (length > THRESHOLD) {
        getStartPath = function (i: number): string {
          const p = starts[i];
          const left = clamp(sliceStart, sliceEnd, p + endOffset);
          const middle = clamp(sliceStart, sliceEnd, p + 2 * strand + endOffset);
          const right = clamp(sliceStart, sliceEnd, p + 3 * strand + endOffset);
          const leftX = x(left - offset);
          const middleX = x(middle - offset);
          const rightX = x(right - offset);
          return `M ${leftX} 0 L ${middleX} 0 L ${rightX} ${
            height / 2
          } L ${middleX} ${height} L ${leftX} ${height} Z`;
        };
      } else {
        getStartPath = function (i: number): string {
          const p = starts[i];
          const pX = x(p - offset);
          return `M ${pX} 0 L ${pX} ${height}`;
        };
      }

      const dataArray = (() => {
        let asc;
        let end1;
        const result = [];
        // eslint-disable-next-line benchlint/disallow-comma-operator
        for (i = 0, end1 = starts.length, asc = 0 <= end1; asc ? i < end1 : i > end1; asc ? i++ : i--) {
          result.push(d);
        }
        return result;
      })();
      const positions = d3
        .select(el)
        .select('g.start-positions')
        .selectAll('path.start-position')
        .data(dataArray);

      positions
        .join('svg:path')
        .classed('start-position', true)
        .classed('layer-fill', true)
        .attr('d', (d, i) => getStartPath(i))
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill', this.layerFill)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill-opacity', this.layerFillOpacity)
        .attr('shape-rendering', 'geometricPrecision')
        .attr('stroke-width', 1.0)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('stroke', this.layerFill);

      const string = `M 0 ${height / 2} L ${width} ${height / 2} L ${width} ${height / 2 + lineHeight} L 0 ${
        height / 2 + lineHeight
      } Z`;
      const backgroundString = `M 0 ${height / 2 - 3} L ${width} ${height / 2 - 3} L ${width} ${
        height / 2 + lineHeight + 3
      } L 0 ${height / 2 + lineHeight + 3} Z`;
      d3.select(el)
        .select('path.line')
        .attr('d', string)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill', this.layerFill)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill-opacity', this.layerFillOpacity);

      // @ts-expect-error: should remove return statement
      return d3
        .select(el)
        .select('path.hidden-background')
        .attr('d', backgroundString)
        .attr('fill', 'white')
        .attr('fill-opacity', 0);
    }
  }
}
ORFsView.initClass();

export default ORFsView;

function __guard__<T, V>(value: Optional<T>, transform: (t: T) => V): V | undefined {
  return value != null ? transform(value) : undefined;
}
function __range__(left: number, right: number, inclusive: boolean): Array<number> {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
